import { ActionIcon, Divider, Image, NumberInput } from "@mantine/core";
import { HiOutlineTrash } from "react-icons/hi2";
import useProductManager from "../../hooks/useProductManager";
import { enhanceCurrency } from "../../utils/formatter";

type CartNavbarDrawerItemProps = {
  id: string;
  typeName: string;
  typeValue: string;
  typeId: string;
  quantity: number;
  onChangeQuantity: (value: number) => void;
  onRemove: () => void;
};

export default function CartNavbarDrawerItem(props: CartNavbarDrawerItemProps) {
  const { data } = useProductManager().get(props.id);

  const price =
    !data || !data.types
      ? undefined
      : { ...data?.types.find((type) => type.id === props.typeId) };

  return (
    <div className="cart-navbar-drawer-item flex flex-col gap-2">
      <div className="flex flex-row gap-2">
        <div className="max-w-[128px] min-w-[128px]">
          <Image src={data?.thumbnailUrl} className="aspect-square w-full" />
        </div>
        <div className="flex flex-row gap-2 flex-1">
          {/* Product Information Sector  */}
          <div className="w-2/3 px-4 flex flex-col gap-2 flex-1">
            <b>{data?.name}</b>
            <NumberInput
              className="w-[120px] "
              radius={"xs"}
              size="sm"
              defaultValue={props.quantity}
              onChange={(value) => props.onChangeQuantity(Number(value))}
              min={1}
              max={20}
            />
            <span className="text-neutral-400 text-xs">
              {props.typeName}: {props.typeValue}
            </span>
          </div>
          {/* Product actions */}
          <div className="flex flex-col gap-2">
            <ActionIcon
              variant="transparent"
              color="red"
              onClick={props.onRemove}
            >
              <HiOutlineTrash />
            </ActionIcon>
          </div>
        </div>
      </div>
      {/* Prices */}
      <div className="py-2 flex flex-row justify-end gap-1 text-sm font-bold">
        <span>Tổng tiền: </span>
        <span className="font-medium text-primary">
          {price !== undefined && (
            <span>
              {enhanceCurrency(
                Number(
                  price.discountPrice !== null
                    ? price.discountPrice
                    : price.actualPrice
                )
              )}
            </span>
          )}{" "}
          đ
        </span>
        <span> x {props.quantity}</span>
        <span> = </span>
        <span className="font-bold text-primary">
          {price !== undefined &&
            enhanceCurrency(
              Number(
                Number(
                  price.discountPrice !== null
                    ? price.discountPrice
                    : price.actualPrice
                ) * props.quantity
              )
            )}{" "}
          đ
        </span>
      </div>
      <Divider className="mb-4" />
    </div>
  );
}
